import React from 'react';
import { getDiscountedPrice } from '../utils/helpers';

interface TermsAndConditionsProps {
  subscriptionType: string;
  promo: any;
}

const TermsConditions: React.FC<TermsAndConditionsProps> = ({
  subscriptionType,
  promo,
}) => {
  return (
    <div
      className="max-w-xl"
      style={{
        // padding: '20px',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.6',
      }}
    >
      {subscriptionType === '1' && (
        <section>
          {/* <h2 className="text-[10px]">3-Day Free Trial</h2> */}
          <p className="text-[10px]">
            By starting the 3-Day Free Trial, you agree to our Terms of Service.
            After the 3-day trial period ends, you authorize us to charge the
            recurring subscription fee of $179.88 annually.
          </p>
          <p className="text-[10px]">
            You may cancel anytime before the end of the trial period to avoid
            being charged. If you do not cancel within the trial period, the
            recurring charge will automatically apply.
          </p>
        </section>
      )}

      {subscriptionType === '2' && (
        <section>
          {/* <h2 className="text-[10px]">Annual Subscription</h2> */}
          <p className="text-[10px]">
            By selecting the Annual Subscription, you agree to{' '}
            {promo?.isValid
              ? `pay $${getDiscountedPrice(
                  179.88,
                  Number(promo?.coupon?.percent_off),
                )} for the first year and`
              : ''}{' '}
            a recurring charge of $179.88 annually. This subscription renews
            automatically unless canceled before the next billing cycle.
          </p>
          <p className="text-[10px]">
            Promo codes applied during checkout provides discount only for the
            first year. Subsequent charges will be at the full price.
          </p>
        </section>
      )}

      {subscriptionType === '3' && (
        <section>
          {/* <h2 className="text-[10px]">2-Year Subscription</h2> */}
          <p className="text-[10px]">
            By selecting the 2-Year Subscription, you agree to
            {promo?.isValid
              ? ` pay $${getDiscountedPrice(
                  323.76,
                  Number(promo?.coupon?.percent_off),
                )} for the first year and`
              : ''}{' '}
            a recurring charge of $323.76 every 2 years. This subscription
            renews automatically unless canceled before the next billing cycle.
          </p>
          <p className="text-[10px]">
            Promo codes applied during checkout provides discount only for the
            first term. Subsequent charges will be at the full price.
          </p>
        </section>
      )}

      <section>
        {/* <h2 className="text-[10px]">Cancellation Policy</h2> */}
        <p className="text-[10px]">
          Cancellation Policy - You can cancel your subscription at any time to
          prevent future charges. However, charges already incurred are
          non-refundable.
        </p>
      </section>

      <section>
        {/* <h2 className="text-[10px]">Agreement</h2> */}
        <p className="text-[10px]">
          Agreement - By proceeding with the checkout process and entering your
          payment details, you acknowledge and agree to our{' '}
          <a className="text-blue-500" href="/terms">
            Terms and Conditions
          </a>
          ,{' '}
          <a className="text-blue-500" href="/privacy">
            Privacy
          </a>{' '}
          and{' '}
          <a className="text-blue-500" href="/cookies">
            Cookie Policy
          </a>
          .
        </p>
      </section>

      {/* <div style={{ marginTop: '20px' }}>
        <label>
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={handleCheckboxChange}
          />
          I accept the Terms and Conditions
        </label>
      </div> */}
    </div>
  );
};

export default TermsConditions;
